import { formatCents } from '@/lib/utils';
import type { LineItemDetails } from '@/types/supplement';

interface LineItemDisplayProps {
  lineItem: LineItemDetails;
}

/**
 * Displays a single line item with description, quantity, unit price, and total
 * Used in both matched and unmatched line item cards
 */
export function LineItemDisplay({ lineItem }: LineItemDisplayProps) {
  return (
    <div className="group border border-slate-200 dark:border-slate-700 rounded bg-background p-2 flex items-center gap-2 min-h-[48px]">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <div className="truncate text-xs font-medium text-foreground">{lineItem.description}</div>
        </div>
        <div className="flex flex-wrap items-center gap-x-2 text-[10px] text-muted-foreground leading-tight">
          {/* Line Item Number */}
          {lineItem.lineItemNumber && (
            <span>#{lineItem.lineItemNumber}</span>
          )}

          {/* Qty and UOM */}
          {lineItem.quantity != null && lineItem.quantity !== 0 && (
            <span>
              {lineItem.quantity} {lineItem.uom}
            </span>
          )}

          {/* Unit Price */}
          {lineItem.unitPriceCents != null && lineItem.unitPriceCents !== 0 && (
            <span>
              @ {formatCents(lineItem.unitPriceCents || 0)}
            </span>
          )}
        </div>
      </div>

      <div className="text-xs font-mono text-muted-foreground">
        {formatCents(lineItem.rcvCents || 0)}
      </div>
    </div>
  );
}
